import React, { Component } from 'react';
import { Table } from 'antd';
import $ from '../../common/AjaxRequest';
import API_URL from '../../common/url';
import dictCache from '../../common/dictCache';
import './style/home.less';
import moment from 'moment';

const monthFormat = 'YYYY-MM';

class PerformanceRankSlot extends Component {
    constructor(props) {
        super(props);
        const { match: { params: { date } }, performanceState = {} } = this.props;
        const { params, pagination } = performanceState;
        const defaultMonth = moment(date).format(monthFormat);
        this.state = {
            searchParams: {
                defaultMonth,
                startDate: defaultMonth,
                endDate: defaultMonth,
                ...params,
            },
            pagination: {
                pageSize: 10,
                current: 1,
                ...pagination,
            },
            loading: false,
            list: [],
            visible: false,
        }
    }

    componentDidMount() {
        this.queryEffectiveDate();
    }

    queryEffectiveDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { year, month } = res;
            const maxDate = `${year}-${month < 10 ? `0${month}` : month}`;
            this.setState({ maxDate }, () => {
                this.loadData();
            });
        });
    }

    loadData = () => {
        const { detailUrl } = this.props;
        const { pagination: { current, pageSize }, searchParams } = this.state;
        const { areaParams = {} } = searchParams;

        this.setState({ loading: true });
        const queryData = {
            offset: current,
            limit: pageSize,
            ...searchParams,
            ...areaParams,
        };
        delete queryData.areaParams;
        delete queryData.hasCheckedArea;
        const options = {
            method: 'POST',
            url: detailUrl,
            data: queryData,
            dataType: 'json',
            doneResult: res => {
                const { pagination } = this.state;
                const { datas, totalCount } = res.result;
                pagination.total = totalCount;
                this.setState({
                    pagination,
                    list: datas,
                    loading: false,
                    meanValue: res.avg,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => {
        const { detailName } = this.props;
        return ([
            {
                title: '排名',
                dataIndex: 'rank',
                key: 'rank',
                width: 85,
            }, {
                title: `${detailName}姓名`,
                dataIndex: 'userCompellation',
                key: 'userCompellation',
                width: 95,
                render: (text, record) => <a onClick={() => this.showDetail(record)}>{text}</a>
            }, {
                title: `${detailName}工号`,
                dataIndex: 'employeeCode',
                key: 'employeeCode',
                width: 95,
            }, {
                title: '职位/级别',
                dataIndex: 'positionName',
                key: 'positionName',
                width: 115,
            }, {
                title: '区域',
                dataIndex: 'areaName',
                key: 'areaName',
                width: 95,
            }, {
                title: '城市',
                dataIndex: 'workCityName',
                key: 'workCityName',
                width: 95,
            },  {
                title: '主管姓名',
                dataIndex: 'leaderUserCompellation',
                key: 'leaderUserCompellation',
                width: 95,
            },  {
                title: '主管工号',
                dataIndex: 'leaderEmployeeCode',
                key: 'leaderEmployeeCode',
                width: 95,
            }, {
                title: '总分',
                dataIndex: 'trueTotalPoint',
                key: 'trueTotalPoint',
                width: 90,
            }, {
                title: '主要业绩分',
                dataIndex: 'mainAchievementPoint',
                key: 'mainAchievementPoint',
                width: 90,
            }, {
                title: '加分',
                dataIndex: 'bonusPoint',
                key: 'bonusPoint',
                width: 90,
            }, {
                title: '减分',
                dataIndex: 'minusPoint',
                key: 'minusPoint',
                width: 90,
            },
        ])
    }

    getDataSource = () => {
        const { list } = this.state;
        const dataSource = list.map((item, index) => (
            {
                index: index + 1,
                ...item,
            }
        ));
        return dataSource;
    }

    showDetail = (record) => {
        const {
            maxDate = '',
            searchParams,
            pagination,
        } = this.state;
        const performanceState = {
            maxDate,
            pagination,
            userId: record.userId,
            params: { ...searchParams },
            userCompellation: record.userCompellation,
            employeeCode: record.employeeCode,
        };
        const { pathName, saveParams } = this.props;
        saveParams(performanceState);
        location.href = `/#/${pathName}`;
    }

    search = (params) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({ searchParams: {...params} }, () => {
            this.loadData();
        })
    }

    export = () => {
        this.changeVisible(true);
    }

    changeVisible = visible => {
        this.setState({ visible });
    }

    handleTableChange = (pagination) => {
        this.setState({
            pagination,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { maxDate = '', loading, meanValue = 0, pagination, searchParams, visible } = this.state;
        const { filterProps, exportProps, detailName } = this.props;
        return (
            <div className="container">
                <div className="full whole-page">
                    <div className="header">
                        {detailName}绩效排行
                        <span className="return-back" 
                            onClick={() =>  this.props.history.push({pathname: `/home`, state: {key: 'performanceRank'}})}
                        >
                            <i
                                className="icon iconfont"
                                style={{ marginRight: 4, fontSize: '20px' }}
                            >&#xe63d;</i>
                            返回
                        </span>
                    </div>
                    {filterProps(maxDate, this.search, this.export, { ...searchParams })}
                    <div style={{ marginBottom: 10, fontWeight: 'bold' }}>均值：{meanValue}</div>
                    <Table
                        bordered
                        loading={loading}
                        scroll={{x: 1130}}
                        pagination={pagination}
                        columns={this.getColumns()}
                        onChange={this.handleTableChange}
                        dataSource={this.getDataSource()}
                        rowKey={record => record.index}
                    />
                    {exportProps(visible, pagination, { ...searchParams }, this.changeVisible)}
                </div>
            </div>
        )
    }
}

export default PerformanceRankSlot;


// WEBPACK FOOTER //
// ./src/components/home/PerformanceRankSlot.js